import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

// Prepends the locale prefix, accepting paths with or without a leading slash.
export const addLocalePrefix = (path, locale = 'en') => {
  const normalised = path.startsWith('/') ? path : `/${path}`;
  return normalised.startsWith(`/${locale}`) ? normalised : `/${locale}${normalised}`;
};

const usePush = () => {
  const navigate = useNavigate();
  const { locale } = useIntl();
  const push = useCallback(path => navigate(addLocalePrefix(path, locale)), [navigate, locale]);
  return { push };
};

export default usePush;
